import React from 'react';

import { MuiThemeProvider, withStyles, WithStyles } from '@material-ui/core/styles';
import { Theme } from "@material-ui/core/styles";

import { AppState, Actions, store, IPageState } from '../../appredux'
import { connect, Provider } from 'react-redux';

import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import { Trans, WithTranslation, withTranslation } from 'react-i18next';
import FormControl from '@material-ui/core/FormControl';
import Checkbox from '@material-ui/core/Checkbox';
import DialogActions from '@material-ui/core/DialogActions';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';

import TextField from '@material-ui/core/TextField';


import { DaneNIPGus, DaneNIPVies, nipService, PokojOpcja, Result, RezerwacjaPobyt } from '../../api';
import { FieldTypes, FormFields, renderFields } from '../common/formFields/renderFields';
import { mobileBreakpoint, PoleDlugosciDwaWWierszu, PoleDlugosciJednoWWierszu } from '../common/formFields/formularzStaleWspolne';
import { TFunction } from 'i18next';
import { Form, Formik, FormikErrors, FormikProps, FormikTouched} from 'formik';
import { FormikTextFieldProps } from '../common/formFields/FormikTextField';
import { capitalizeFirstLetter, containsAnyLetter, sendErrorLog, selectTheme } from '../common/helpers';
import MuiCheckbox from 'app/common/formFields/MuiCheckbox';
import DialogComponent from 'app/common/DialogComponent';
import { Content } from 'app/Notifier';
import ReactDOM from 'react-dom';
import theme from 'themes/themes';
import Klawiatura from 'app/common/Klawiatura';
import CONFIG from 'cfg/config';

interface FormValues {
  nip: string,
  nazwa: string,
  kod: string,
  miasto: string,
  ulica: string,
  info: string,
}

type ModalProps = {
  page: IPageState,
  theme: string,
  options: PokojOpcja[],
  czyPobytZmieniany: boolean,
  zmienianyPobyt: RezerwacjaPobyt,
  openFormularzFaktura: number,
  optionsValues: string[],
  initialValues: FormValues,

  checked: string[],
  changeChecked: (event: React.ChangeEvent<HTMLInputElement>) => void,
}

type ModalState = {
  open: boolean,
  values: FormValues,
  width: number,

  openSaveInfo: boolean
}

//const secondaryLight = theme.palette.secondary.light;

//let stylInputa : React.CSSProperties = {};
let stylInputa: React.CSSProperties = { padding: "8px 14px", fontWeight: "normal", textAlign: "left" };

class NotifierOptions extends React.Component<ModalProps & WithTranslation & WithStyles<typeof styles>, ModalState> {
  secondaryLight =   selectTheme(this.props.theme).palette.secondary.light;

  //oblicza na ile lini w inpucie textarea jest miejsca
  calculateRows = (ileCheckboxow: number) => {
    const wysokoscCheckboxow = 42 * Math.ceil(this.state.width <= 1280 ? ileCheckboxow / 2 : ileCheckboxow / 3);
    const dostepnaWysokosc = window.innerHeight - 315.797 - wysokoscCheckboxow;
    return String(Math.floor(dostepnaWysokosc / 19));
  }

  state = {
    open: false,
    values: {nip: '', nazwa: '', kod: '', miasto: '', ulica: '', info: ''},
    width: window.innerWidth,

    openSaveInfo: false
  };

  closeSave = () => {
    this.setState({openSaveInfo: false})
  }

  handleModalClose = () => {
    //anulowanie
    //store.dispatch(Actions.pageState.setOptionsValues(["0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0"]));
    this.setState({
      open: false,
    });

  };

  handleModalCloseButton = () => {
    //zapisanie
    //store.dispatch(Actions.pageState.setOptionsValues(this.state.checked));
    this.setState({
      open: false,
    });

  };

  componentDidMount() {
    this.updateWindowWidth();
    window.addEventListener('resize', this.updateWindowWidth);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowWidth);
  }

  updateWindowWidth = () => {
    this.setState({ ...this.state, width: window.innerWidth });
  }

  //PM 2021-10-22
  //wstrzykniecie tylko uzywanych pol z magazynu danych
  async componentDidUpdate(prevProps: ModalProps) {
    if (this.props.openFormularzFaktura !== prevProps.openFormularzFaktura) {
      //stylInputa = stylInputaDomyslny; 
      //await store.dispatch(Actions.pageState.setOptionsValues(["0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0"]));
      this.setState({
        open: true,
        //checked: this.props.optionsValues
      });
    };
  }

  async dajDanePoNIP(nip: string, setFieldValue: {(field: string, value: any, shouldValidate?: boolean): void;}) {
    try {
      const res: DaneNIPGus = await nipService.dajDanePoNip({
        nip: nip
      }, {})
      if (res != null && res.nazwa !== "") {
        let adres = res.kodPocztowy + " " + res.miejscowosc + ", " + res.ulica; 
        setFieldValue("nazwa", res.nazwa);
        //setFieldValue("kod", res.kodPocztowy);
        setFieldValue("miasto", adres);
        //setFieldValue("ulica", res.ulica);
        //if(!this.props.czyPobytZmieniany){
          await store.dispatch(Actions.pageState.setDaneNIP({nip: nip.toUpperCase(), adres: adres, kontrNazwa: res.nazwa}))
        //}  
      } else {
        setFieldValue("nazwa", "");
        setFieldValue("miasto", "");
        await store.dispatch(Actions.pageState.setDaneNIP({nip: "", adres: "", kontrNazwa: ""}))
      }
      
    } catch (error) {
      await sendErrorLog("0", "-1", '/gus/dajDanePoNip')
      await store.dispatch(Actions.pageState.addFcmLogMessage("/gus/dajDanePoNip", 2))
      console.log(error)
    }
  }

  async dajDanePoVies(kod: string, nip: string, setFieldValue: {(field: string, value: any, shouldValidate?: boolean): void;}) {
    try {
      const res: DaneNIPVies = await nipService.dajDanePoVies({
        kod: kod.toUpperCase(),
        vat: nip
      }, {})

      if (res != null && res.nazwa !== null && res.nazwa !== "" && res.nazwa !== "---" && res.miejscowosc !== "" && res.miejscowosc !== "---") {
        setFieldValue("nazwa", res.nazwa);
        //setFieldValue("kod", '');
        setFieldValue("miasto", res.miejscowosc);
        //setFieldValue("ulica", '');
        //if(!this.props.czyPobytZmieniany){
        await store.dispatch(Actions.pageState.setDaneNIP({nip: nip.toUpperCase(), adres: res.miejscowosc, kontrNazwa: res.nazwa}))
        //}
      } else {
        setFieldValue("nazwa", "");
        setFieldValue("miasto", "");
        await store.dispatch(Actions.pageState.setDaneNIP({nip: "", adres: "", kontrNazwa: ""}))
      }

    } catch (error) {
      await sendErrorLog("0", "-1", '/gus/dajDanePoVies')
      await store.dispatch(Actions.pageState.addFcmLogMessage("/gus/dajDanePoVies", 2))
      console.log(error)
    }
  }

  onNIPChanged = (
    //event: React.ChangeEvent<{ name?: string; value: any }>,
    val: string,
    values: FormValues, 
    setFieldValue: {
      (field: string, value: any, shouldValidate?: boolean): void;
    }) => {
    //let nip: string = event.target.value
    let nip: string = val
    nip = nip.split(" ").join("");
    if(nip[0] &&(nip[0] === "." || nip[0] === "," || nip[0] === "-")){
      nip = nip.substring(1, nip.length)
    }

    if (nip.length >= 10) { //values.nazwa === "" && values.kod === "" && values.miasto === "" && 
      setTimeout(async () => {
        //console.log('containsAnyLetter - ' + containsAnyLetter(nip))
        let kod = nip.replace(/[0-9]/g,''); //tylko litery
        let vat = nip.replace(/\D/g,''); // tylko numery

        if(containsAnyLetter(nip) && kod.length === 2){
          await this.dajDanePoVies(kod, vat, setFieldValue);
        }else if(!containsAnyLetter(nip) && kod.length === 0 && nip.length === 10){
          await this.dajDanePoNIP(nip, setFieldValue);
        }
      }, 500);
    } else if (nip === ""){
      setFieldValue("nazwa", "");
      setFieldValue("miasto", "");
    }
  }

  formFields = (
    setFieldValue: (
      field: string,
      value: any,
      shouldValidate?: boolean
    ) => void,
    values: FormValues,
    handleChange: (e: React.ChangeEvent<any>) => void,
    touched: FormikTouched<FormValues>,
    errors: FormikErrors<FormValues>
  ): FormFields[] => {
    const { t, classes } = this.props;
    //const zapisanyFormularz = this.props.zapisanyFormularz.pokoj !== ''

    return [
      {
        block:
        {
          type: FieldTypes.formikText,
          props: {
            formControlStyle: {marginTop: "20px"},
            key: 'NIP',
            label: 'NIP',
            labelClasses: classes.primary,
            name: 'nip',
            style: {
              width: this.state.width <= mobileBreakpoint ? PoleDlugosciJednoWWierszu.CALA_DLUGOSC.value.mobile : PoleDlugosciJednoWWierszu.CALA_DLUGOSC.value.PC,
              marginTop: '2px', marginBottom: '1px',
            },
            inputClasses: `${classes.textSecondary} ${classes.floatLeft} ${classes.backgroundWhite} ${classes.textAlignLeft} ${classes.uppercase} ${classes.fontWeightNormal}`,
            //completed: this.props.czyPobytZmieniany || (zapisanyFormularz && this.props.initialValues.name),
            value: values.nip,
            placeholder: '8130068147',
            onChange: (e: React.ChangeEvent<{ name?: string; value: any }>) => { handleChange(e); this.onNIPChanged(e.target.value, values, setFieldValue) },
            onClick: CONFIG.hotelKiosk === "1" ? (e: React.ChangeEvent<{ name?: string; value: any }>) => {this.openKlawiaturaNip(e, values, setFieldValue, handleChange)} : null,
            touched: touched.nip,
            error: errors.nip,
            autoFocus: true,
          } as FormikTextFieldProps,
        },
      },
      {
        block:
        {
          type: FieldTypes.formikText,
          props: {
            key: 'Nazwa',
            label: t('Generic name'),
            labelClasses: classes.primary,
            name: 'nazwa',
            style: {
              width: this.state.width <= mobileBreakpoint ? PoleDlugosciJednoWWierszu.CALA_DLUGOSC.value.mobile : PoleDlugosciJednoWWierszu.CALA_DLUGOSC.value.PC,
              marginTop: '1px', marginBottom: '1px'
            },
            inputClasses: `${classes.paddingMl} ${classes.textSecondary} ${classes.floatLeft} ${classes.backgroundWhite} ${classes.textAlignLeft} ${classes.uppercase} ${classes.fontWeightNormal}`,
            //completed: this.props.czyPobytZmieniany || (zapisanyFormularz && this.props.initialValues.name),
            value: values.nazwa,
            onChange: handleChange,
            onClick: CONFIG.hotelKiosk === "1" ? () => this.openKlawiaturaNazwa(values.nazwa, setFieldValue) : null,
            touched: touched.nazwa,
            error: errors.nazwa,
            multiline: true,
            rows: this.state.width <= mobileBreakpoint ? 6 : 6
          } as FormikTextFieldProps,
        },
      },
      // {
      //   block:
      //   {
      //     type: FieldTypes.formikText,
      //     props: {
      //       key: 'Kod',
      //       label: 'Kod',
      //       name: 'kod',
      //       style: {
      //         width: this.state.width <= mobileBreakpoint ? PoleDlugosciJednoWWierszu.CALA_DLUGOSC.value.mobile : PoleDlugosciJednoWWierszu.CALA_DLUGOSC.value.PC,
      //         marginTop: '3px', marginBottom: '3px',
      //       },
      //       inputClasses: `${classes.textSecondary} ${classes.floatLeft} ${classes.backgroundWhite} ${classes.textAlignLeft} ${classes.uppercase} ${classes.fontWeightNormal}`,
      //       //completed: this.props.czyPobytZmieniany || (zapisanyFormularz && this.props.initialValues.name),
      //       value: values.kod,
      //       onChange: handleChange,
      //       touched: touched.kod,
      //       error: errors.kod
      //     } as FormikTextFieldProps,
      //   },
      // },
      {
        block:
        {
          type: FieldTypes.formikText,
          props: {
            key: 'Adres',
            label: capitalizeFirstLetter(t('Address')),
            labelClasses: classes.primary,
            name: 'miasto',
            style: {
              width: this.state.width <= mobileBreakpoint ? PoleDlugosciJednoWWierszu.CALA_DLUGOSC.value.mobile : PoleDlugosciJednoWWierszu.CALA_DLUGOSC.value.PC,
              marginTop: '1px', marginBottom: '2px',
            },
            inputClasses: `${classes.paddingMl} ${classes.textSecondary} ${classes.floatLeft} ${classes.backgroundWhite} ${classes.textAlignLeft} ${classes.uppercase} ${classes.fontWeightNormal}`,
            //completed: this.props.czyPobytZmieniany || (zapisanyFormularz && this.props.initialValues.name),
            value: values.miasto,
            onChange: handleChange,
            onClick: CONFIG.hotelKiosk === "1" ? () => this.openKlawiaturaAdres(values.miasto, setFieldValue) : null,
            touched: touched.miasto,
            error: errors.miasto,
            multiline: true,
            rows: this.state.width <= mobileBreakpoint ? 6 : 6
          } as FormikTextFieldProps,
        },
      },
      // {
      //   block:
      //   {
      //     type: FieldTypes.formikText,
      //     props: {
      //       key: 'Ulica',
      //       label: 'Ulica',
      //       name: 'ulica',
      //       style: {
      //         width: this.state.width <= mobileBreakpoint ? PoleDlugosciJednoWWierszu.CALA_DLUGOSC.value.mobile : PoleDlugosciJednoWWierszu.CALA_DLUGOSC.value.PC,
      //         marginTop: '3px', marginBottom: '3px',
      //       },
      //       inputClasses: `${classes.textSecondary} ${classes.floatLeft} ${classes.backgroundWhite} ${classes.textAlignLeft} ${classes.uppercase} ${classes.fontWeightNormal}`,
      //       //completed: this.props.czyPobytZmieniany || (zapisanyFormularz && this.props.initialValues.name),
      //       value: values.ulica,
      //       onChange: handleChange,
      //       touched: touched.ulica,
      //       error: errors.ulica
      //     } as FormikTextFieldProps,
      //   },
      // },
      // {
      //   block:
      //   {
      //     type: FieldTypes.formikText,
      //     props: {
      //       key: 'Info',
      //       label: 'Info',
      //       name: 'info',
      //       style: {
      //         width: this.state.width <= mobileBreakpoint ? PoleDlugosciJednoWWierszu.CALA_DLUGOSC.value.mobile : PoleDlugosciJednoWWierszu.CALA_DLUGOSC.value.PC,
      //         marginTop: '3px', marginBottom: '3px',
      //       },
      //       inputClasses: `${classes.textSecondary} ${classes.floatLeft} ${classes.backgroundWhite} ${classes.textAlignLeft} ${classes.uppercase} ${classes.fontWeightNormal}`,
      //       //completed: this.props.czyPobytZmieniany || (zapisanyFormularz && this.props.initialValues.name),
      //       value: values.info,
      //       onChange: handleChange,
      //       touched: touched.info,
      //       error: errors.info
      //     } as FormikTextFieldProps,
      //   },
      // },
    ];
  }

  formFieldsRender = (
    setFieldValue: (
      field: string,
      value: any,
      shouldValidate?: boolean
    ) => void,
    values: FormValues,
    handleChange: (e: React.ChangeEvent<any>) => void,
    touched: FormikTouched<FormValues>,
    errors: FormikErrors<FormValues>
  ) => {
    const { classes } = this.props;

    return (
      <React.Fragment>
        {renderFields(this.formFields(setFieldValue, values, handleChange, touched, errors))}
        {/* <Typography className={`${classes.label} ${classes.legend}`} color="error">
          <Trans>Field must be filled</Trans>
        </Typography> */}
      </React.Fragment>
    )
  }

  openKlawiaturaNip = ( event: React.ChangeEvent<{ name?: string; value: any }>,values: FormValues,  setFieldValue: (field: string, value: any, shouldValidate?: boolean) => void, handleChange: (e: React.ChangeEvent<any>) => void,) => {
    const { t, classes } = this.props;
    ReactDOM.render(
        <Provider store={store}>
            <MuiThemeProvider theme={theme}>
                <Klawiatura  randomNum={Math.random()} val={values.nip} type={"number"} placeholder={"NIP"} onConfirm={(val: string) => {handleChange(event),setFieldValue('nip', val);this.onNIPChanged(val, values, setFieldValue) }} /> 
            </MuiThemeProvider>
        </Provider>, document.getElementById("dialogKlawiatura"))
  }
  openKlawiaturaNazwa = (val: string,  setFieldValue: (field: string, value: any, shouldValidate?: boolean) => void) => {
    const { t, classes } = this.props;
    ReactDOM.render(
        <Provider store={store}>
            <MuiThemeProvider theme={theme}>
                <Klawiatura  randomNum={Math.random()} val={val} type={"default"} placeholder={t('Generic name')} onConfirm={(val: string) => setFieldValue('nazwa', val)} /> 
            </MuiThemeProvider>
        </Provider>, document.getElementById("dialogKlawiatura"))
  }
  openKlawiaturaAdres = (val: string,  setFieldValue: (field: string, value: any, shouldValidate?: boolean) => void) => {
    const { t, classes } = this.props;
    ReactDOM.render(
        <Provider store={store}>
            <MuiThemeProvider theme={theme}>
                <Klawiatura  randomNum={Math.random()} val={val} type={"default"} placeholder={capitalizeFirstLetter(t('Address'))} onConfirm={(val: string) => setFieldValue("miasto", val)} /> 
            </MuiThemeProvider>
        </Provider>, document.getElementById("dialogKlawiatura"))
  }

  render() {
    const { t, classes } = this.props;

    const dialogContent: Content[] = [
      {
          message: t("Invoice confirm") + "?"
      },
    ]



    return (
      // <Dialog PaperProps={{ className: classes.dialogPaper }}
      //           fullWidth
      //           maxWidth="sm"
      //           open={this.state.open}
      //         >
      //           <DialogContent
      //             className={classes.dialogContent}
      //             style={{ paddingTop: '8px' }}
      //           >
                  <span className={`${classes.spanOuter}`}>
                    <Formik
                      initialValues={this.props.initialValues}
                      validate={values => {
                        let errors = {}
                        // if (!values.nip) {
                        //   errors = { ...errors, nip: t("Required") };
                        // }
                        // if (!values.nazwa) {
                        //   errors = { ...errors, email: t("Required") };
                        // }
                        return errors;
                      }}
                      onSubmit={(values, formikActions) => {
                        this.setState({openSaveInfo: false})
                        setTimeout(async () => {
                          await store.dispatch(Actions.pageState.setDaneNIP({nip: values.nip.toUpperCase(), adres: values.miasto, kontrNazwa: values.nazwa}))
                          formikActions.setSubmitting(false)
                          this.handleModalCloseButton();
                        }, 500)
                      }}
                      render={({ submitForm, isSubmitting, values, setFieldValue, handleChange, touched, errors }: FormikProps<FormValues>) => (
                        // <Form className={classes.form} onChange={this.props.czyPobytZmieniany ? () => {} : submitForm} >
                        <Form className={classes.form} onChange={submitForm} >

                          {/* <DialogTitle disableTypography style={{ padding: "0" }}>
                            <Typography variant="h6" component="h2" color="primary"  style={{fontSize: "1rem", padding: "2px 8px" }}>
                              <b style={{fontSize: "10px",textTransform: "uppercase", color: "rgb(182, 59, 77)" }}><Trans>Invoice data</Trans></b>
                            </Typography>
                            <hr style={{borderStyle: "none none solid none", borderBottom: "1px solid #e0e0e0", marginBlockStart: "2px"}} />
                          </DialogTitle> */}


                          {this.formFieldsRender(setFieldValue, values, handleChange, touched, errors)}

                          <div style={{ }}>

                            {this.props.options[13] && this.props.options[13].aktywna === "1" && this.props.options[13].opis.trim() === "auto fkt" ?
                              <MuiCheckbox
                                formControlStyle={{ marginTop: 0, marginBottom: "35px", marginLeft: "-11px" }}
                                key={"0"}
                                id={"13"}
                                label={t("Want invoice")}
                                //labelHTML={<span><Trans>Terms</Trans> <a href={`https://vsc24.net/vscZasady/zasady/Regulamin/${CONFIG.zasady1Link}`} target="_blank" rel="noreferrer" className={classes.link}>{CONFIG.zasady1Opis}</a></span>}
                                labelClasses={classes.primary}
                                //labelStyle={{paddingLeft: "10px"}}
                                labelBlock

                                checkboxFirst
                                checked={this.props.checked[13] === "1" ? true : false}//{this.state.potwierdzona}
                                onChange={this.props.changeChecked}
                              />
                              : null}
                          </div> 

                          {/* <DialogActions style={this.state.width <= mobileBreakpoint ?
                            {} : { position: "relative", bottom: "0px", width: "95.5%" }}>
                            <Button variant="outlined" color="primary" size="small"
                              className={classes.actionButtons}
                              onClick={this.handleModalCloseButton}>
                              <b><Trans>Back</Trans></b>
                            </Button>
                            <Button variant="contained" color="primary" size="small"
                              className={classes.actionButtons}
                              disabled={isSubmitting}
                              onClick={submitForm}
                              style={{ marginRight: this.state.width <= mobileBreakpoint ? "30.5px" : "0px" }}
                            >
                              <b><Trans>{ "Save" }</Trans></b>
                            </Button>
                          </DialogActions> */}

                          {/* style={this.state.width <= mobileBreakpoint ?
                            {} : { position: "absolute", bottom: "8px", width: "45.54%" }} */}
                          {/* {this.props.czyPobytZmieniany ? 
                          <DialogActions >
                           
                            <Button variant="contained" color="primary" size="small"
                              className={classes.actionButtons}
                              //disabled={isSubmitting || !this.state.rightFieldsRender}
                              onClick={() => {this.setState({openSaveInfo: true})}}
                              style={{ marginRight: this.state.width <= mobileBreakpoint ? "0" : "0px" }}
                            >
                              <b><Trans>{"Save"}</Trans></b>
                            </Button>
                          </DialogActions> : null } */}

                          <DialogComponent open={this.state.openSaveInfo} title={t("Choose")} okShow okCallback={submitForm} okText={t("Save")} cancelShow cancelCallback={this.closeSave} dialogContent={dialogContent} windowWidth={this.state.width} />
                        </Form>
                      )}
                    />


                    
                  </span>
              //   </DialogContent>
              // </Dialog>
    );
  }
}

const styles = (theme: Theme) => ({
  headline: {
    fontFamily: "\"'Open Sans'\", sans-serif",
    lineHeight: "20px",
    fontSize: "14px",
    fontWeight: 600,
    marginBottom: "0px"
  },
  secondary: {
    color: theme.palette.secondary.main
  },
  alert: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    background: '#ffffff',
    padding: "42px 70px 42px 70px",
    maxWidth: "727px",
    outline: 0
  },
  textField: {
    marginLeft: "6px",
    //marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: 200,
  },
  black: {
    //color: "rgb(0, 0, 0)",
    color: theme.palette.text.secondary,
    backgroundColor: "inherit",
    textAlign: 'left' as 'left',
  },
  label: {
    //fontFamilly: "sans-serif",
    //fontSize: "small"
    fontSize: "12px",
    fontFamily: "\"Arial\", \"Helvetica\", sans-serif",
    lineHeight: "20px",
    fontWeight: theme.typography.body2.fontWeight,
    padding: "7px 0 4px"
  },
  dialogContent: {
    paddingTop: 0
  },

  textAlignLeft: {
    textAlign: "left" as "left",
  },
  fontWeightNormal: {
      fontWeight: "normal" as "normal"
  },
  textSecondary: {
      //color: theme.palette.text.secondary
      color: theme.palette.primary.main
  },
  floatLeft: {
      float: "left" as "left"
  },
  textAlignCenter: {
      textAlign: "center" as "center",
  },
  backgroundWhite: {
      backgroundColor: "#ffffff"
  },
  formControl: {
    display: "block",
    //paddingBottom: "35px"
  },
  uppercase: {
    textTransform: "uppercase" as "uppercase",
  },
  button: {
    height: "35px",
  },
  legend: {
    padding: "35px 8px 35px 0px"
  },
  dialogPaper: {
    //maxHeight: "100%",
    //maxWidth: "1177px",
    minWidth: "350px",
  },
  spanOuter: {
    maxWidth: "552px",
    minWidth: "350px",
    width: "100%"
  },
  spanOuterLeft: {
    backgroundColor: "#f9f9f9",
    paddingLeft: "12px"
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  floatRight: {
    float: "right" as "right"
  },
  actionButtons: {
    textTransform: "lowercase" as "lowercase"
  },
  paddingMl: {
    padding: "8px 14px"
  },
  primary: {
    color: theme.palette.primary.main
  },
});

const mapStateToProps = (state: AppState) => ({
  page: state.pageState,
  theme: state.pageState.theme,
  options: state.pageState.options,
  czyPobytZmieniany: state.pageState.czyPobytZmieniany,
  zmienianyPobyt: state.pageState.zmienianyPobyt,
  openFormularzFaktura: state.pageState.openFormularzFaktura,
  optionsValues: state.pageState.optionsValues,
  values: state.pageState.formValues,
  initialValues: {
    nip: state.pageState.daneNIP.nip.trim(), 
    miasto: state.pageState.daneNIP.adres.trim(), 
    nazwa: state.pageState.daneNIP.kontrNazwa.trim(),
    kod: '',
    ulica: '',
    info: ''}
});

export default withStyles(styles)(connect(mapStateToProps)(withTranslation()(NotifierOptions)));